<template>
  <transition name="ui-popup-show">
    <div v-if="show && routeResolver" class="ui-popup" @touchstart.stop @touchmove.stop @touchend.stop>
      <div class="ui-popup-content">
        <img :src="popupImgUrl" alt="" class="ui-popup-main" @click="click">
        <img src="../../assets/icons/popup-close.svg" alt="" class="ui-popup-close" @click="close">
      </div>
    </div>
  </transition>
</template>

<script>
import keys from 'lodash.keys'
import { mapGetters } from 'vuex'
import module from '../../modules/popup'
import * as get from '@ccforeverd/tool-get'

const { client } = get.query()
const isClient10 = parseInt(client) === 10 // 办公助手公众号

export default {
  data () {
    return {
      show: false
    }
  },

  computed: {
    ...mapGetters(keys(module.getters)),

    routeResolver () {
      return /mine-page$|recommend$|today$/.test(this.$route.name)
    }
  },

  watch: {
    popupImgUrl () {
      this.scan()
    }
  },

  methods: {
    scan () {
      if (this.popupImgUrl) {
        const img = new Image(this.popupImgUrl)
        img.onload = () => (this.show = true)
        img.src = this.popupImgUrl
      }
    },

    click () {
      const { jumpType, jumpUrl } = this.popupShowData

      this.close()

      setTimeout(() => {
        switch (jumpType) {
          case 1:
            this.$router.push(`/sign-up?market=h5-pop-up&courseId=${jumpUrl}`)
            return
          case 2:
            alert('暂时不支持专题')
            return
          case 3:
            return window.location.href = jumpUrl // 'javascript:;'
        }
      }, 300)
    },

    close () {
      this.show = false
      this.$store.dispatch('closePopup')
    }
  },

  mounted () {
    this.scan()
  }
}
</script>

<style lang="scss">
@charset "utf-8";
@import "../../style/main";

.ui-popup {
  @include fixed('tlrbwh');
  z-index: 9999999;
  background-color: rgba($color: #000000, $alpha: .55);
  @include center-flex();

  &-show {
    &-enter-active, &-leave-active {
      transition: opacity .5s;
    }
    &-enter, &-leave-to {
      opacity: 0;
    }
    &-enter-active {
      transition-delay: .3s;
    }
  }

  &-content {
    position: relative;
    width: rem(630);
  }

  &-main {
    display: block;
    width: 100%;
  }

  &-close {
    position: absolute;
    display: block;
    right: rem(-40);
    top: rem(-40);
    @include square(40);
  }
}

</style>
